<template>
  <div :class="[{'d-none':!show}, 'position-relative']">
    <img
      :src="src"
      :class="[imageClass, loading ? 'opacity-25' : '']"
      :style="style"
      @error="onLoadError"
      @load="onLoad"
    />
    <div v-if="loading" class="small position-absolute top-50 start-50 translate-middle">
      Loading
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    imageClass: String,
    size: {
      type: Number,
      default: () => 64
    },
    fit: {
      type: String,
      default: () => 'cover'
    },
    autoSize: Boolean,
    autoWidth: Boolean,
    autoHeight: Boolean,
    maxHeight: Number
  },
  data() {
    return {
      loaded: null,
      error: null
    };
  },
  watch: {
    src(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.loaded = null;
        this.error = null;
      }
    }
  },
  computed: {
    style() {
      let style = `object-fit:${this.fit};`;
      if (!this.autoSize) {
        if (!this.autoWidth) {
          style += `width:${this.size}px;`;
        }
        if (!this.autoHeight) {
          style += `height:${this.size}px;`;
        }
      }
      if (this.maxHeight > 0) {
        style += `max-height:${this.maxHeight}px`;
      }
      return style;
    },
    loading() {
      return !this.loaded && !this.error;
    },
    show() {
      return !!this.src && !this.error;
    }
  },
  methods: {
    onLoad(event) {
      this.loaded = event;
    },
    onLoadError(error) {
      this.error = error;
    }
  }
}
</script>
